import React, { useEffect, useState } from 'react';
import { Result, Root } from '../../types';
import Session from './Session';

// Styles
import styles from './sessions.module.css';

/**
 * Renders the group coaching tiles
 *
 * Usage:
 *
 * Required Props:
 *    baseUri (defaults to https://cms.ramseysolutions.net/api/coaching-sessions)
 *
 * Optional Props:
 *    firstName
 *    lastName
 *    email
 *    path
 *
 * ```jsx
 * <Sessions
 *    baseUri="path/to/sessions/endpoint"
 *    path="ramsey_plus"
 *    firstName="John"
 *    lastName="Doe"
 *    email="johndoe@gmail.com />
 * ```
 */

type CalendarProps = {
  baseUri: string;
  '@path'?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
};

function Sessions({ baseUri, firstName, lastName, email }: CalendarProps) {
  const [data, setData] = useState<Result[]>([]);

  useEffect(() => {
    const BASE_URI =
      baseUri || 'https://cms.ramseysolutions.net/api/coaching-sessions';
    function getData(): Promise<Result[]> {
      return fetch(BASE_URI)
        .then((res: { json: () => any }) => res.json())
        .then((result: Root) => (result as Root).results as Result[]);
    }
    getData().then(item => setData(item));
  }, []);

  return (
    <>
      <div className={styles.sessions}>
        {data ? (
          data.map(
            session =>
              session['@path'].includes('ramsey_plus') && (
                <Session
                  key={session.name}
                  title={session.title}
                  summary={session.summary}
                  icon={session.icon}
                  duration={session.duration}
                  calendar_key={session.calendar_key}
                  name={`${firstName} ${lastName}`}
                  email={email}
                />
              )
          )
        ) : (
          <p>
            It looks like there was a problem loading the Group Coaching
            sessions. Please refresh the page to try again.
          </p>
        )}
        {}
      </div>
    </>
  );
}

export default Sessions;
